import { ELOOP } from "constants"

const  dienste={

    Brief:{
        color: 'yellow',
        name: 'Brief',
        capture: {
            facingMode: "environment", aspectRatio: { exact: 0.7}, width: 1080 
         },                 // no barcode scanning, data for ocr
        codeTypes:[],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    Brief2:{
        color: 'yellow',
        name: 'Brief Lable',
        capture: { facingMode: "environment", aspectRatio: { exact: 0.7}, width: 600 },
        codeTypes: ['code_128',],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    DHL:
    {
        color: 'yellow',
        name: 'DHL',
        capture: { facingMode: "environment",  width: 600, aspectRatio: { exact: 0.7}},
        codeTypes: ['code_128','itf'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    DHLE:
    {
        color: 'yellow',
        name:'DHL-Express',
        capture: { facingMode: "environment", aspectRatio: { exact: 0.7}, width: 600},
        codeTypes: ['code_128',],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    GLS:
    {
        name:'GLS',
        color:'orange',
        capture: { facingMode: "environment", aspectRatio: { exact: 1.0}, width:600},
        codeTypes: [ /*'aztec', 'codabar',*/ 'data_matrix'],
        codeProcess:(code)=>{
            if(code)
            {
                const elements=code.split(' ')
                if(elements.length>1)
                {
                    const result=code.match(/\s+\d{6,}[0-4a-z]*{?([A-Z].[A-Z0-9]{8,})\s/)
                    return result[1].substr(0,8)
                }
            }
            return null
        }
    },
    HERMES:
    {
        name:'Hermes',
        color:'blue',
        capture: { facingMode: "environment", aspectRatio: { exact: 0.7}, width: 600 },
        codeTypes: ['code_128'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    DPD:
    {
        name:'DPD',
        color:'red',
        capture: { facingMode: "environment", aspectRatio: { exact: 0.7}, width: 600 },
        codeTypes: ['code_128'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    UPS:
    {
        name:'UPS',
        color:'brown',
        capture: { facingMode: "environment", aspectRatio: { exact: 0.7}, width: 600 },
        codeTypes: ['code_128'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },  
    PRIME:
    {
        name:'PRIME',
        color:'green',
        capture: { facingMode: "environment", width:500, height: 500 , aspectRatio: { exact: 1} , resizeMode:'none'},
        codeTypes:['data_matrix'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    },
    Info:
    {
        name:'Info',
        color:'orange',
        capture: { facingMode: "environment", aspectRatio: { exact: 1}, width: 600, height: 600 },
        codeTypes: ['code_128','data_matrix'],
        codeProcess:(el)=>(el.replace(/^]C1|^%/,''))
    } 


}
export default dienste

